import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { AxiosError } from 'axios';
import { Redirect, useParams } from 'react-router-dom';
import { ForbiddenErrorMessage } from '../../../global/components/forbidden-error-message';
import { useAdminStatus } from '../../../global/hooks/useAdminStatus';
import { useBasePath } from '../../../global/hooks/useBasePath';
import { ArcRoutes } from '../constants/routes';
import { AnnualEnrollmentRoutes } from '../../annual-enrollment/constants/annual-enrollment-routes';
import { AccountInfoRoutes } from '../../account-info/constants/routes';
import { useParticipantState } from '../features/participants/useParticipantState';
import { setCurrentEmployee } from '../features/employment/employment-slice';
import { TcsmStates } from '../../../root/tcsm-model';
import { useRoleObject } from './useRoles';

export function AEDeeplinkRedirect() {	
	const dispatch = useDispatch();
	const roles = useRoleObject();
	const isAdmin = useAdminStatus(roles);
	const params : any = useParams();	
	const annualEnrollmentPath = useBasePath(`${ArcRoutes.ArcRoot}${AnnualEnrollmentRoutes.AnnualEnrollment}${AccountInfoRoutes.PersonalInfoSegment}`);

	const errors = useSelector<TcsmStates, AxiosError[]>(state => state.apiState.error);

	const participantState = useParticipantState(params?.groupId, params?.billingAccountId);	

	const [loadingContentError, setLoadingContentError] = useState<boolean>(false);
	const [memberLoaded, setMemberLoaded] = useState<boolean>(false);

	const missingData = !(params.clientid && params.billingAccountId && params.groupId);

	function TriggerUnavaliableContent(){
		setMemberLoaded(true);
		setLoadingContentError(true);
	}

	useEffect(() => {
		if ((!participantState.billingAccountDetailLoaded && participantState.requesting) ||
			!participantState?.billingAccountDetail ) return;

		if (!missingData && participantState?.billingAccountDetail?.covered_people?.length > 0){			
			const foundParticipants = participantState.billingAccountDetail.covered_people.filter((p)=> p.guid === params.clientid);

			if (foundParticipants?.length > 0 && foundParticipants[0].ae_available) {
				setLoadingContentError(false);
				dispatch(setCurrentEmployee(foundParticipants[0]));
				setMemberLoaded(true);
				return;
			}			
		} 

		TriggerUnavaliableContent();
	}, [participantState?.billingAccountDetail?.covered_people?.length, participantState.billingAccountDetailLoaded, participantState.requesting]);

	if (!isAdmin || loadingContentError || missingData || (errors?.length > 0)) {
		return <ForbiddenErrorMessage />;
	}

	if (!participantState.billingAccountDetailLoaded || 
		participantState.requesting ||
		!memberLoaded){
		return (<LoadingCircle />);
	}

	return (
		<>			
			<Redirect to={{
				pathname: annualEnrollmentPath,				
			}} />
		</>
	);
}
